module.exports = __webpack_public_path__ + "2b997bbfaac6c3bbee6ebdecc2f893db.pdf";